const loadJs = (src) => new Promise((resolve, reject) => {
    const tag = document.createElement('script');
    tag.type = 'text/javascript';
    tag.async = false;
    tag.addEventListener('load', resolve);
    tag.addEventListener('error', reject);
    tag.src = src;
    document.body.appendChild(tag);
});

export { loadJs };
//# sourceMappingURL=loadJs.js.map
